/* Native fixed bundle parent maps to original component variants; paid Puffer Air add-on remains separate. */
(() => {
  if(window.AlpinePurchaseOptions?.version==='launch-20261022') return;
  window.AlpinePurchaseOptions={version:'launch-20261022'};
  document.documentElement.dataset.alpinePowerRuntime='launch-20261022';
  const initialized=new WeakSet();
  function initRoot(outer){
    if(!outer)return;
    const root=outer.matches('.product-section')?outer:outer.querySelector('.product-section'),form=root?.querySelector('form[action*="/cart/add"]');if(!form)return;
    const initKey=root.querySelector('[data-alpine-power]')||outer.querySelector('[data-alpine-editions]');if(!initKey||initialized.has(initKey))return;
    const dataNode=outer.querySelector('[data-alpine-native-data], [data-alpine-power-main-data]');
    const variantNode=root.querySelector('[data-variant-json]');if(!dataNode&&!variantNode)return;
    const d=dataNode?JSON.parse(dataNode.textContent):{variants:JSON.parse(variantNode.value||variantNode.textContent),options:[]};initialized.add(initKey);
    const suffix=root.id||root.dataset.sectionId;root.querySelectorAll('[data-alpine-power] input[type=radio]').forEach(el=>el.name='alpine-power-'+suffix);
    const powerSelect=root.querySelector('[data-power-variant]');if(powerSelect){const label=root.querySelector('label[for="'+powerSelect.id+'"]');powerSelect.id='power-colour-'+suffix;if(label)label.htmlFor=powerSelect.id;}
    if(outer.querySelector('[data-edition-reselect="1"]')||new URL(location.href).searchParams.get('edition_reselect')==='1'){const note=outer.querySelector('[data-alpine-editions] .alpine-purchase-note');if(note){note.textContent='此版本沒有剛才選擇的顏色／尺寸，請重新確認下方規格。';note.setAttribute('role','status');}}
    const current=()=>d.variants.find(v=>String(v.id)===String(form.elements.namedItem('id')?.value));
    const options=v=>v?.options||[];
    const index=(p,re)=>p.options.findIndex(n=>re.test(typeof n==='string'?n:n.name));
    const normalized=v=>({'黑':'經典黑','棕':'土星棕'}[v]||v);
    function syncEditions(){
      const v=current();if(!v)return;
      const colour=normalized(options(v)[index(d,/color|colour|顏色/i)]),size=options(v)[index(d,/size|尺寸|尺碼/i)];
      outer.querySelectorAll('[data-edition-product]').forEach(node=>{
        const p=JSON.parse(node.textContent),ci=index(p,/color|colour|顏色/i),si=index(p,/size|尺寸|尺碼/i);
        // Preserve an exact size/colour even if sold out; never silently substitute another available size.
        const match=p.variants.find(x=>normalized(options(x)[ci])===colour&&options(x)[si]===size);
        const u=new URL(p.url,location.origin),here=new URL(location.href);
        u.searchParams.set('view','alpine-family-design-review');
        for(const name of ['presentation','preview_theme_id'])if(here.searchParams.has(name))u.searchParams.set(name,here.searchParams.get(name));
        if(!u.searchParams.has('preview_theme_id')&&window.Shopify?.theme?.role==='unpublished')u.searchParams.set('preview_theme_id',Shopify.theme.id);
        if(match)u.searchParams.set('variant',match.id);else u.searchParams.set('edition_reselect','1');
        const link=outer.querySelector('[data-edition-id="'+p.id+'"]');if(link)link.href=u.href;
      });
    }
    const power=outer.querySelector('[data-alpine-power]');
    let syncPower=()=>{};
    if(power){
      const bank=JSON.parse(power.querySelector('[data-power-product]').textContent),details=power.querySelector('[data-power-details]'),select=power.querySelector('[data-power-variant]'),error=power.querySelector('[data-power-error]');
      const bundleNode=power.querySelector('[data-power-bundle]'),bundle=bundleNode?JSON.parse(bundleNode.textContent):null;
      const bundleActive=()=>bundle&&Date.now()<Date.parse(bundle.endsAt);
      const bundleVariant=(v,b)=>{const mapped=bundle?.mapping.find(m=>String(m.outer)===String(v?.id)&&String(m.power)===String(b?.id));return bundle?.variants.find(x=>String(x.id)===String(mapped?.id));};
      const enabled=()=>power.querySelector('input[value="with-power"]').checked;
      const selectedBank=()=>bank.variants.find(v=>String(v.id)===select.value);
      const dynamic=[...form.querySelectorAll('.shopify-payment-button')].map(el=>({el,hidden:el.hidden}));
      const money=cents=>new Intl.NumberFormat('zh-TW',{style:'currency',currency:bank.currency||'TWD',maximumFractionDigits:0}).format(cents/100);
      let busy=false,uncertain=false;
      syncPower=()=>{
        details.hidden=!enabled();select.disabled=!enabled();
        dynamic.forEach(x=>{x.el.hidden=enabled()||x.hidden;});
        const v=current(),b=selectedBank();
        if(bundle){
          for(const option of select.options){const bankVariant=bank.variants.find(x=>String(x.id)===option.value);option.disabled=!bankVariant?.available||!bundleVariant(v,bankVariant)?.available;}
          const matched=bundleVariant(v,b);
          power.querySelector('[data-power-total]').textContent=!bundleActive()?'超早鳥已結束，請重新整理頁面。':matched?.available?'組合 '+money(matched.price)+'・行動電源已包含':'此尺寸與電源顏色組合暫時售完';
        }else power.querySelector('[data-power-total]').textContent=v&&b?'搭配合計 '+money(v.price+b.price)+'／組':'';
      };
      power.hidden=false;
      power.addEventListener('change',syncPower);
      // Native Alpine availability/media guard runs on the parent first. Only intercept an explicitly selected add-on.
      form.addEventListener('submit',async event=>{
        if(!enabled()||event.defaultPrevented)return;
        event.preventDefault();event.stopImmediatePropagation();
        if(busy||uncertain)return;
        const v=current(),b=selectedBank(),qty=Number(new FormData(form).get('quantity')||1);
        error.hidden=true;
        if(!v?.available||!b?.available||!Number.isSafeInteger(qty)||qty<1){error.textContent='請確認商品規格與數量。';error.hidden=false;return;}
        const matched=bundleVariant(v,b);
        if(bundle&&(!bundleActive()||!matched?.available)){error.textContent=bundleActive()?'請選擇有庫存的尺寸與電源顏色。':'超早鳥已結束，請重新整理頁面。';error.hidden=false;return;}
        const properties={};for(const [k,value] of new FormData(form))if(/^properties\[.+\]$/.test(k))properties[k.slice(11,-1)]=value;
        const button=form.querySelector('[type=submit]'),wasDisabled=button?.disabled;
        if(wasDisabled)return;
        busy=true;power.setAttribute('aria-busy','true');if(button)button.disabled=true;
        try{
          const response=await fetch(bank.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:bundle?[{id:matched.id,quantity:qty,properties}]:[{id:v.id,quantity:qty,properties},{id:b.id,quantity:qty}]})});
          // On uncertainty, inspect cart rather than automatically repeat a potentially accepted request.
          let result;try{result=await response.json();}catch{throw new Error('unconfirmed');}
          if(!response.ok){
            error.textContent=(result.description||result.message||'目前無法加入，請確認庫存。')+' 請先查看購物車，再決定是否重新加入。';error.hidden=false;
            uncertain=true;
          }else{
            if(document.getElementById('CartDrawerForm')){
              form.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:result.items?.[0]||result,addToCartBtn:button},bubbles:true}));
            }else{location.assign(bank.cartUrl);}
            return;
          }
        }catch{
          uncertain=true;error.textContent='尚未確認加入結果，請先查看購物車，避免重複加入。';error.hidden=false;
        }finally{
          busy=false;power.removeAttribute('aria-busy');if(button)button.disabled=uncertain||wasDisabled;
          if(uncertain){const a=document.createElement('a');a.href=bank.cartUrl;a.textContent=' 查看購物車';error.append(a);}
        }
      },true);
      addEventListener('pageshow',()=>{busy=false;syncPower();});
    }
    const sync=()=>requestAnimationFrame(()=>{syncEditions();syncPower();});
    root.addEventListener('variantChange',sync);root.addEventListener('change',sync);sync();
  }
  const safelyInit=el=>{try{initRoot(el);}catch(error){el.dataset.alpinePowerError=error.message;}};
  const init=()=>{document.querySelectorAll('[data-alpine-native-pdp]').forEach(safelyInit);document.querySelectorAll('[data-alpine-power]').forEach(el=>safelyInit(el.closest('.product-section')));};
  window.AlpinePurchaseOptions.init=init;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  new MutationObserver(records=>{if(records.some(r=>r.addedNodes.length))init();}).observe(document.documentElement,{childList:true,subtree:true});
})();

(() => {
 const place=()=>{
  const pairs=document.querySelector('[data-alpine-pairing]');
  const product=document.querySelector('[data-alpine-native-pdp] .product-section');
  const form=product?.querySelector('form[action*="/cart/add"]');
  if(!pairs||!form)return;
  form.after(pairs);pairs.dataset.pairingPlaced='true';
  const rail=pairs.querySelector('[data-pair-rail]');
  const context=new URL(location.href).searchParams.get('presentation')==='women'?'women':'men';
  rail.dataset.recommendationContext=context;
  rail.querySelectorAll('article[data-context]').forEach(card=>{card.hidden=!['unisex',context].includes(card.dataset.context);});
  const visible=[...rail.querySelectorAll('article')].filter(card=>!card.hidden);
  const count=pairs.querySelector('[data-pair-count]'),prev=pairs.querySelector('[data-pair-prev]'),next=pairs.querySelector('[data-pair-next]');
  const step=()=>visible.length>2?visible[2].offsetLeft-visible[0].offsetLeft:rail.clientWidth;
  const update=()=>{const page=Math.round(rail.scrollLeft/Math.max(1,step()));const pages=Math.ceil(visible.length/2);count.textContent=(page+1)+' / '+pages;prev.disabled=page===0;next.disabled=page>=pages-1;};
  const move=direction=>rail.scrollBy({left:direction*step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
  rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
  rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',place,{once:true});else place();
})();


